
import Vue from "vue"
import Component from "vue-class-component"
import names from "./router"
import CookieLaw from "vue-cookie-law"
import Poster from "./util/poster"
import FilialeDetailRequest from "./entities/common/request/filiale_detail_request"
import RemoteResult from "./entities/common/remote_result"
import BestellungFiliale from "./entities/common/bestellung_filiale"
import RestPaths from "./util/rest_paths"
import vuexStore from "./store"
import MainLogic from "./logic/main_logic"
import IdRequest from "./entities/common/request/id_request"
import Pending from "./entities/common/pending"

@Component({ components: { CookieLaw } })
export default class App extends Vue {
  drawer = false
  memberLoggedIn = false

  websocket = null
  links = names
  mainLogic: MainLogic = null

  mounted() {
    fetch("/identifier-v.1.0.txt", { cache: "no-store" })
      .then((response) => response.text())
      .then((data) => {
        var url = data.trim()

        MainLogic.init()
        this.mainLogic = MainLogic.getInstance()
        var request = new FilialeDetailRequest()
        request.urlPath = url

        Poster.postUser<RemoteResult<BestellungFiliale>>(
          RestPaths.filialeDetailsNachUrl,
          request
        ).then((response) => {
          if (response.data.success) {
            var filiale = response.data.payload
            this.mainLogic.filiale = filiale

            var idRequest = new IdRequest()
            idRequest.id = vuexStore.state.user.identifier

            Poster.postUser<RemoteResult<Pending>>(
              RestPaths.bestellungpendingDetails,
              idRequest
            ).then((response) => {
              this.mainLogic.bestellungPending =
                response.data.payload.bestellung
              this.mainLogic.neueBestellung =
                response.data.payload.bestellung != null
              this.mainLogic.reservierungPending =
                response.data.payload.reservierung

              this.mainLogic.neueReservierung =
                response.data.payload.reservierung != null
            })
          }
        })
      })
  }
}
